import { ProductError, ProductErrorType } from '../../models';

export class DragAndDropData {
  defaultIcon?: string;
  groups: DragAndDropGroup[];

  constructor(dragAndDropData: DragAndDropData) {
    if (dragAndDropData) {
      this.defaultIcon = dragAndDropData.defaultIcon;
      this.groups = (dragAndDropData.groups || []).map(g => new DragAndDropGroup(g));
    } else {
      this.groups = [];
    }
  }

  static validate(data: DragAndDropData): ProductError[] {
    if (!data.groups || data.groups.length < 2) {
      return [{ type: ProductErrorType.NOT_ENOUGH_VALUE, property: 'groups' }];
    }
    return data.groups
      .map((group, groupIndex) => DragAndDropGroup.validate(group, groupIndex))
      .reduce((flattened, subArray) => flattened.concat(subArray));
  }
}

export class DragAndDropGroup {
  title: string;
  icon?: string;
  index?: number; // use for "arrow scrolling" on mobile version
  isModeSort?: boolean;
  items: string[];
  selectedItems?: string[];

  constructor(group: DragAndDropGroup) {
    this.title = group.title;
    this.icon = group.icon;
    this.index = group.index;
    this.isModeSort = group.isModeSort || false;
    this.items = group.items ? [...group.items] : [];
    this.selectedItems = [];
  }

  static validate(group: DragAndDropGroup, groupIndex: number): ProductError[] {
    const errors: ProductError[] = [];
    if (!group.title) {
      errors.push({
        type: ProductErrorType.MISSING,
        property: `groups[${groupIndex}].title`,
        payload: { groupIndex },
      });
    }
    if (!group.items || !group.items.length) {
      errors.push({
        type: ProductErrorType.MISSING,
        property: `groups[${groupIndex}].items`,
        payload: { groupIndex },
      });
    } else {
      group.items
        .filter(item => !item)
        .map(itemIndex => ({
          type: ProductErrorType.MISSING,
          property: `groups[${groupIndex}].items[${itemIndex}]`,
          payload: { groupIndex, itemIndex },
        }))
        .forEach(error => errors.push(error));
    }
    return errors;
  }
}
